import { useEffect, useState } from 'react';
import { AUDITED_UNIT_DEFAULT, AUDITED_UNIT_OPTIONS } from './auditedStatementLayout';

/**
 * The units (INR / Lakhs / Crore) viewer preference, shared by Audited and Provisional Financials.
 *
 * Extracted (RECUR-27640) because both surfaces had their own copy of the same three things — the
 * validated lazy-init from localStorage, the persist effect, and the private-mode try/catch. Two
 * copies of "what happens when the stored value is unknown or storage is blocked" is precisely the
 * shape that drifts on the next change.
 *
 * The two surfaces keep SEPARATE storage keys on purpose, so changing the scale on one does not
 * silently rewrite the other's preference — the key is the parameter, the behaviour is shared.
 */
export function useUnitPreference(storageKey: string) {
    const [unit, setUnit] = useState<string>(() => {
        try {
            const saved = localStorage.getItem(storageKey);
            return saved && AUDITED_UNIT_OPTIONS.includes(saved) ? saved : AUDITED_UNIT_DEFAULT;
        } catch {
            return AUDITED_UNIT_DEFAULT;
        }
    });

    useEffect(() => {
        try {
            localStorage.setItem(storageKey, unit);
        } catch {
            /* storage unavailable (e.g. private mode) — non-fatal, selection just won't persist */
        }
    }, [storageKey, unit]);

    return [unit, setUnit] as const;
}
